import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Select,
  Spinner,
  Box,
  Badge,
  Divider,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";

const BulkOrderTransferDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleSelectChangeProfessor = (newValue) => {
    setSelectedProfessor(newValue);
  };
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalReject, setActiveModalReject] = useState(false);
  const [activeModalApprove, setActiveModalApprove] = useState(false);
  const [ts, setTs] = useState("");

  const handleSubmit = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 2);
    form_data.append("professor_id", selectedProfessor);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModal(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleReject = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 3);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModalReject(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleApprove = () => {};
  const handleChangeModal = () => {
    setActiveModal(false);
  };

  const handleChangeModalReject = () => {
    setActiveModalReject(false);
  };
  const handleChangeModalApprove = () => {
    setActiveModalApprove(false);
  };
  const [result, setResult] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/bulk-order-transfer/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }
  const switchStatusText = (status) => {
    switch (status) {
      case "registered_allocation":
        return "Registered Allocation";
      case "in_progress":
        return "In Progress";
      case "closed":
        return "Closed";
      case "completed":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      default:
        return "";
    }
  };
  const switchStatusColor = (status) => {
    switch (status) {
      case "registered_allocation":
        return "attention";
      case "in_progress":
        return "";
      case "completed":
        return "success";
      case "closed":
        return "critical";
      default:
        return "";
    }
  };
  return result ? (
    <Page
      backAction={{
        onAction: () => navigate("/admin/bulk-order-transfer"),
      }}
      title={result?.shipment_number}
      titleMetadata={
        <Badge tone={switchStatusColor(result?.status)}>
          {switchStatusText(result?.status)}
        </Badge>
      }
      //   secondaryActions={[
      //     {
      //       content: `Set as ${result?.completed ? "uncompleted" : "completed"}`,
      //       loading: isSaving,
      //       // icon: CheckIcon,
      //       onAction: () => {
      //         setIsSaving(true);
      //         axios
      //           .patch(`/tournament-uprades/${id}/complete`, {
      //             completed: result?.completed ? 0 : 1,
      //           })
      //           .then((result) => {
      //             setIsSaving(false);
      //             //setActiveModal(false);
      //             setTs(+new Date());
      //           })
      //           .catch((err) => console.log(err));
      //       },
      //     },
      //   ]}
      // title={result?.first_name + " " + result?.last_name}
      // titleMetadata={
      //   result?.completed && <Badge tone="success">Completed</Badge>
      // }
      //   secondaryActions={[
      //     {
      //       content: "Approve",
      //       icon: CheckIcon,
      //       onAction: () => {
      //         setActiveModal(true);
      //       },
      //     },
      //     {
      //       content: "Reject",
      //       destructive: true,
      //       icon: XIcon,
      //       onAction: () => {
      //         setActiveModalReject(true);
      //       },
      //     },
      //   ]}
    >
      <Card>
        <Box paddingBlock="200">
          <FormLayout>
            <FormLayout.Group condensed>
              <Text>
                <b>Order Number</b>
                <br />
                {result?.shipment_number ? result?.shipment_number : "-"}
              </Text>
              <Text>
                <b>Address</b>
                <br />
                {result?.address ? result?.address : "-"}
              </Text>
              <Text>
                <b>Status</b>
                <br />
                {result?.status ? switchStatusText(result?.status) : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Time</b>
                <br />
                {result?.created_at
                  ? moment(result.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>

              <Text>
                <b>Assigned Driver</b>
                <br />
                {`${
                  result?.driver?.first_name ? result?.driver?.first_name : ""
                } ${
                  result?.driver?.last_name ? result?.driver?.last_name : ""
                }`}
              </Text>
              <Text>
                <b>Delivery Sequence</b>
                <br />
                {result?.delivery_sequence ? result?.delivery_sequence : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Coordinate Status</b>
                <br />
                {result?.coordinate_status ? result?.coordinate_status : "-"}
              </Text>
              <Text></Text>
              <Text></Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Notes</b>
                <br />
                {result?.notes ? result?.notes : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Box>
      </Card>

      <Modal
        open={activeModal}
        onClose={handleChangeModal}
        title="Approve Request"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModal,
          },
        ]}
      >
        <Modal.Section>
          <Select
            label="Please assign a professor"
            options={optionsProfessors}
            onChange={handleSelectChangeProfessor}
            value={selectedProfessor}
            placeholder="Please select"
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalReject}
        onClose={handleChangeModalReject}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleReject,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalReject,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalApprove}
        onClose={handleChangeModalApprove}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleApprove,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalApprove,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default BulkOrderTransferDetails;
